<template>
  <base-layout>
    <template v-slot:header>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Pošalji izveštaj
      </h1>
    </template>
    <template v-slot:default>
      <form class="space-y-8 divide-y divide-gray-200">
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Završetak promocije
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              Nakon završetka promocije obavezno je poslati izveštaj.
            </p>
          </div>
          <div>
            <div class="mt-6">
              <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-6 max-w-xl">
                  <label for="consumers-contacted" class="text-base font-medium text-gray-900">
                    Broj kontaktiranih potrošača
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input
                        type="text"
                        name="consumers-contacted"
                        id="consumers-contacted"
                        autocomplete="consumers-contacted"
                        class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        v-model="numberOfContactedBuyers"
                        required
                    >
                  </div>
                </div>
                <div class="sm:col-span-6 max-w-xl"
                     v-for="(question, index) in promotion.activePromotion.additional_questions"
                     :key="index"
                >
                  <label for="consumers-contacted" class="text-base font-medium text-gray-900" :id="`question${question.id}`">
                    {{ question.question }}
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input
                        type="text"
                        autocomplete="consumers-contacted"
                        class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        :ref="`question${question.id}`"
                        required
                    >
                  </div>
                </div>


                <div class="sm:col-span-6 max-w-xl" v-if="missingProductsAtStartArray">
                  <label for="comments2" class="text-base font-medium text-gray-900">
                    Šifre proizvoda kojih nije bilo na početku promocije
                  </label>
                  <ul class="divide-y divide-gray-200">
                    <li class="py-4" v-for="(product, index) in missingProductsAtStartArray" :key="index">
                      <div class="flex items-center space-x-4">
                        <div class="flex-1 min-w-0">
                          <p class="text-sm font-medium text-gray-900 truncate">
                            ({{ product.bnr }}) -  {{ product.name }}
                          </p>
                        </div>
                        <div>
                          <a
                              href="#"
                              class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                              @click.prevent="removeProductFromStart(product.name)"
                          >
                            Ukloni
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="sm:col-span-6 flex max-w-xl">
                  <div class="relative flex items-stretch flex-grow focus-within:z-10">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <!-- Heroicon name: solid/users -->
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                    </div>
                    <input
                        type="text"
                        name="email"
                        id="email"
                        class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-300"
                        placeholder="BNR proizvoda"
                        @keyup="searchNewProduct('start')"
                        ref="searchTerm"
                    >
                  </div>

                  <button
                      class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      @click.prevent="clearSearchTermFromStart"
                  >
                    Resetuj
                  </button>
                </div>
                <div class="sm:col-span-6 max-w-xl" v-if="potentialProducts.length">
                  <ul class="divide-y divide-gray-200">
                    <li class="py-4" v-for="(product, index) in potentialProducts" :key="index">
                      <div class="flex items-center space-x-4">
                        <div class="flex-1 min-w-0">
                          <p class="text-sm font-medium text-gray-900 truncate">
                            ({{ product.bnr }}) - {{ product.name }}
                          </p>
                        </div>
                        <div>
                          <a
                              href="#"
                              class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                              @click.prevent="addToMissingProducts(product.bnr, product.name)"
                          >
                            Dodaj
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>




                <div class="sm:col-span-6 max-w-xl" v-if="missingProductsAtEndArray">
                  <label for="comments2" class="text-base font-medium text-gray-900">
                    Šifre proizvoda kojih nije bilo na kraju promocije
                  </label>
                  <ul class="divide-y divide-gray-200">
                    <li class="py-4" v-for="(product, index) in missingProductsAtEndArray" :key="index">
                      <div class="flex items-center space-x-4">
                        <div class="flex-1 min-w-0">
                          <p class="text-sm font-medium text-gray-900 truncate">
                            ({{ product.bnr }}) - {{ product.name }}
                          </p>
                        </div>
                        <div>
                          <a
                              href="#"
                              class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                              @click.prevent="removeProductFromEnd(product.name)"
                          >
                            Ukloni
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="sm:col-span-6 flex max-w-xl">
                  <div class="relative flex items-stretch flex-grow focus-within:z-10">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <!-- Heroicon name: solid/users -->
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                    </div>
                    <input
                        type="text"
                        name="email"
                        id="email2"
                        class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-300"
                        placeholder="BNR proizvoda"
                        @keyup="searchNewProduct('end')"
                        ref="searchTermEnd"
                    >
                  </div>

                  <button
                      class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      @click.prevent="clearSearchTermFromEnd"
                  >
                    Resetuj
                  </button>
                </div>
                <div class="sm:col-span-6 max-w-xl" v-if="potentialProductsAtEnd.length">
                  <ul class="divide-y divide-gray-200">
                    <li class="py-4" v-for="(product, index) in potentialProductsAtEnd" :key="index">
                      <div class="flex items-center space-x-4">
                        <div class="flex-1 min-w-0">
                          <p class="text-sm font-medium text-gray-900 truncate">
                            ({{ product.bnr }}) - {{ product.name }}
                          </p>
                        </div>
                        <div>
                          <a
                              href="#"
                              class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                              @click.prevent="addToMissingProductsAtEnd(product.bnr, product.name)"
                          >
                            Dodaj
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>


                <div class="sm:col-span-6 max-w-xl">
                  <label for="comments3" class="text-base font-medium text-gray-900">
                    Komentar
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <textarea
                        id="comments3"
                        name="comments"
                        rows="3"
                        class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="Unesi komentar"
                        v-model="promoterComment"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-5">
          <div class="flex justify-end">
            <button
                type="button"
                class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="goBack"
            >
              Otkaži
            </button>
            <button
                type="submit"
                class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click.prevent="showModal = true"
            >
              Nastavi
            </button>
          </div>
        </div>
      </form>

      <Modal
          v-show="showModal"
          @accept="endPromotion"
          @close="showModal = false"
      />
    </template>
  </base-layout>
</template>

<script>
import PromotionCompletionDermo from './PromotionCompletionDermo';
export default PromotionCompletionDermo;
</script>
